import type {
	CustomItem,
	DropCountdownType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropCountdown = (
	item: Item | CustomItem
): item is DropCountdownType => {
	return !!(item && item.__typename === 'Drop_Countdown');
};
